

import React from "react";
import heartLoading from "../../assests/heartLoading.gif";
import { Tooltip } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { Search } from "lucide-react";
import { ArrowUp, ArrowDown } from "lucide-react";
import Skeleton from "@mui/material/Skeleton";





const Tables = ({
  tableData = [],
  loading = false,
  ruleCount = 0,
  error = null,
  pagination = { page: 1, pageSize: 10, totalPages: 0, totalCount: 0 },
  onPageChange = () => {},
    onColumnSearchChange = () => {},  
      columnSearch = {},  
          onSortChange = () => {},


}) => {
  const items = [
    { color: "#FB0301", label: "< 90%" },
    { color: "#FFC100", label: "90% – 95%" },
    { color: "#009F52", label: "≥ 95%" },
  ];
  const tableContainerRef = React.useRef(null);
  const [sortColumn, setSortColumn] = React.useState(null);
const [sortOrder, setSortOrder] = React.useState("asc");

const handleSort = (column) => {
  let newOrder = "asc";
  if (sortColumn === column && sortOrder === "asc") {
    newOrder = "desc";
  }
  setSortColumn(column);
  setSortOrder(newOrder);

  if (typeof onSortChange === "function") {
    onSortChange(column, newOrder);
  }
};
const handleResetInputs = () => {
  if (typeof onColumnSearchChange === "function") {
    Object.keys(columnSearch).forEach((col) => onColumnSearchChange(col, ""));
  }
};
  const renderHighlightedText = (text, searchTerm) => {
  if (!searchTerm || !text) return text;

  const parts = text.split(new RegExp(`(${searchTerm})`, "gi"));
  return parts.map((part, i) =>
    part.toLowerCase() === searchTerm.toLowerCase() ? (
      <span key={i} style={{ backgroundColor: "orange", fontWeight: "500" }}>
        {part}
      </span>
    ) : (
      part
    )
  );
};

  const truncateText = (text, maxLength = 30) =>
    text && text.length > maxLength ? `${text.slice(0, maxLength)}...` : text || "NA";
  const truncateTexts = (text, maxLength = 15) =>
    text && text.length > maxLength ? `${text.slice(0, maxLength)}...` : text || "NA";

  // if (loading) {
  //   return (
  //     <div className="flex items-center justify-center w-full overflow-hidden mt-20">
  //       <div className="text-center flex flex-col items-center justify-center space-y-4">
  //         <img src={heartLoading} alt="Loading..." className="h-32 w-32" />
  //         <div className="space-y-2">
  //           <p className="text-gray-700 text-xl font-semibold">Applying filters...</p>
  //           <p className="text-gray-500 text-base">Updating results based on your selection</p>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  if (error) {
    return <div className="p-4 text-red-600">Error: {error}</div>;
  }

  const totalRecords = pagination.totalCount || 0;
  const pageSize = pagination.pageSize || 10;
  const currentPage = pagination.page || 1;
  const totalPages =
    pagination.totalPages && pagination.totalPages > 0
      ? pagination.totalPages
      : Math.max(1, Math.ceil(totalRecords / pageSize));

  const gotoPage = (p) => {
    const target = Math.max(1, Math.min(totalPages, p));
    if (target !== currentPage) onPageChange(target);
  };

  return (
    <div className="poppins-regular">
      {/* Rule Count */}
     

      {/* Score Legend & Pagination (unchanged) */}
      <div className="flex items-center justify-between w-full mb-4">
        <div className="flex items-center space-x-8">
          <div className="flex space-x-6">
            {items.map((item, idx) => (
              <div key={idx} className="flex items-center space-x-2">
                <div
                  className="w-[14px] h-[50px] rounded-full"
                  style={{ backgroundColor: item.color.trim() }}
                />
                <div className="flex flex-col text-sm text-gray-500">
                  <span className="labeling-items" style={{ fontSize: "12px" }}>
                    Quality Score
                  </span>
                  <span className="labeling-items" style={{ fontSize: "12px" }}>
                    {item.label}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Pagination */}
        <div>
          {totalRecords > 0 && (
            <div className="pagination">
              <div className="pagination-controls flex items-center gap-2">
                <button
                  disabled={currentPage === 1}
                  onClick={() => gotoPage(currentPage - 1)}
                  className="px-3 py-1 border rounded disabled:opacity-50"
                >
                  Previous
                </button>

                {(() => {
                  const pageButtons = [];
                  const totalToShow = 5;

                  let start = Math.max(1, currentPage - Math.floor(totalToShow / 2));
                  let end = start + totalToShow - 1;

                  if (end > totalPages) {
                    end = totalPages;
                    start = Math.max(1, end - totalToShow + 1);
                  }

                  if (start > 1) pageButtons.push(1);
                  if (start > 2) pageButtons.push("...");

                  for (let i = start; i <= end; i++) {
                    pageButtons.push(i);
                  }

                  if (end < totalPages - 1) pageButtons.push("...");
                  if (end < totalPages) pageButtons.push(totalPages);

                  return pageButtons.map((p, idx) =>
                    p === "..." ? (
                      <span key={idx} className="px-2">
                        ...
                      </span>
                    ) : (
                      <button
                        key={idx}
                        onClick={() => gotoPage(p)}
                        className={`px-3 py-1 border rounded ${
                          currentPage === p ? "bg-[#bb1ccc] text-white" : ""
                        }`}
                      >
                        {p}
                      </button>
                    )
                  );
                })()}

                <button
                  disabled={currentPage === totalPages}
                  onClick={() => gotoPage(currentPage + 1)}
                  className="px-3 py-1 border rounded disabled:opacity-50"
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      
      <div className="flex justify-between items-center">
        {/* Left side items */}
        <div className="flex items-center gap-3 mb-[10px]">
          {/* Search Input */}
        
      
          {/* Reset button */}
          <button className="px-3 mt-[4px] w-[100px] py-1 text-gray-700 bg-white border border-gray-300 rounded" 
                        onClick={handleResetInputs}

        >
            Reset
          </button>
      
          {/* Scroll section */}
       <div className="flex items-center gap-1 mt-[2px]">
       <ChevronLeft
        title="Scroll Left"
          className="cursor-pointer"
          onClick={() => {
            if (tableContainerRef.current) {
              tableContainerRef.current.scrollBy({ left: -200, behavior: "smooth" });
            }
          }}
        />
        <p className="text-[12px]">Scroll</p>
        <ChevronRight
          className="cursor-pointer"
          title="Scroll Right"
          onClick={() => {
            if (tableContainerRef.current) {
              tableContainerRef.current.scrollBy({ left: 200, behavior: "smooth" });
            }
          }}
        />
      </div>
      
        </div>
      
        {/* Right side - Export */}
        <div className="mb-[10px]">
        <span className="bg-blue-100 text-blue-800 text-sm px-3 py-1 rounded-md shadow-sm">
          THERE ARE {ruleCount} UNIQUE RULES FOUND
        </span>
      </div>
      </div>
      

      {/* Table */}
<div
  ref={tableContainerRef}
  style={{ overflowX: "auto", scrollBehavior: "smooth" }}
>          <table className="min-w-full border-collapse border border-gray-200 text-sm">
        
     <thead className="bg-[#9897FF1A] text-[#404040]">
  {/* Header Row */}
  <tr>
    <th
      onClick={() => handleSort("data_product_name")}
      className="px-4 pb-[6px] pt-[10px] text-[10px] text-left font-semibold w-[200px] cursor-pointer select-none"
    >
      <span
        className={`flex items-center gap-1 ${
          sortColumn === "data_product_name" ? "text-[#0000A0]" : ""
        }`}
      >
        Data Product Name
        {sortColumn === "data_product_name" ? (
          sortOrder === "asc" ? (
            <ArrowUp size={12} />
          ) : (
            <ArrowDown size={12} />
          )
        ) : (
          <ArrowUp size={12} className="opacity-30" />
        )}
      </span>
    </th>
<th
      onClick={() => handleSort("data_asset_name")}
      className="px-4 pb-[6px] pt-[10px] text-[10px] text-left font-semibold w-[200px] cursor-pointer select-none"
    >
      <span
        className={`flex items-center gap-1 ${
          sortColumn === "data_asset_name" ? "text-[#0000A0]" : ""
        }`}
      >
        Data Asset Name
        {sortColumn === "data_asset_name" ? (
          sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />
        ) : (
          <ArrowUp size={12} className="opacity-30" />
        )}
      </span>
    </th>  
 <th
      onClick={() => handleSort("rule_name")}
      className="px-4 pb-[6px] pt-[10px] text-[10px] text-left font-semibold w-[200px] cursor-pointer select-none"
    >
      <span
        className={`flex items-center gap-1 ${
          sortColumn === "rule_name" ? "text-[#0000A0]" : ""
        }`}
      >
        Rule Name
        {sortColumn === "rule_name" ? (
          sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />
        ) : (
          <ArrowUp size={12} className="opacity-30" />
        )}
      </span>
    </th> 
    <th
      onClick={() => handleSort("rule_description")}
      className="px-4 pb-[6px] pt-[10px] text-[10px] text-left font-semibold w-[200px] cursor-pointer select-none"
    >
      <span
        className={`flex items-center gap-1 ${
          sortColumn === "rule_description" ? "text-[#0000A0]" : ""
        }`}
      >
        Rule Description
        {sortColumn === "rule_description" ? (
          sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />
        ) : (
          <ArrowUp size={12} className="opacity-30" />
        )}
      </span>
    </th>
<th
      onClick={() => handleSort("check_name")}
      className="px-4 pb-[6px] pt-[10px] text-[10px] text-left font-semibold w-[200px] cursor-pointer select-none"
    >
      <span
        className={`flex items-center gap-1 ${
          sortColumn === "check_name" ? "text-[#0000A0]" : ""
        }`}
      >
        Check Name
        {sortColumn === "check_name" ? (
          sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />
        ) : (
          <ArrowUp size={12} className="opacity-30" />
        )}
      </span>
    </th> 
<th
      onClick={() => handleSort("dimension_name")}
      className="px-4 pb-[6px] pt-[10px] text-[10px] text-left font-semibold w-[200px] cursor-pointer select-none"
    >
      <span
        className={`flex items-center gap-1 ${
          sortColumn === "dimension_name" ? "text-[#0000A0]" : ""
        }`}
      >
        Dimension Name
        {sortColumn === "dimension_name" ? (
          sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />
        ) : (
          <ArrowUp size={12} className="opacity-30" />
        )}
      </span>
    </th>  
 <th
      onClick={() => handleSort("total_row_count")}
      className="px-4 pb-[6px] pt-[10px] text-[10px] text-left font-semibold w-[200px] cursor-pointer select-none"
    >
      <span
        className={`flex items-center gap-1 ${
          sortColumn === "total_row_count" ? "text-[#0000A0]" : ""
        }`}
      >
        Total Rows
        {sortColumn === "total_row_count" ? (
          sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />
        ) : (
          <ArrowUp size={12} className="opacity-30" />
        )}
      </span>
    </th> 
<th
      onClick={() => handleSort("error_record_count")}
      className="px-4 pb-[6px] pt-[10px] text-[10px] text-left font-semibold w-[200px] cursor-pointer select-none"
    >
      <span
        className={`flex items-center gap-1 ${
          sortColumn === "error_record_count" ? "text-[#0000A0]" : ""
        }`}
      >
        Error Rows
        {sortColumn === "error_record_count" ? (
          sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />
        ) : (
          <ArrowUp size={12} className="opacity-30" />
        )}
      </span>
    </th>  
<th
      onClick={() => handleSort("quality_score")}
      className="px-4 pb-[6px] pt-[10px] text-[10px] text-left font-semibold w-[200px] cursor-pointer select-none"
    >
      <span
        className={`flex items-center gap-1 ${
          sortColumn === "quality_score" ? "text-[#0000A0]" : ""
        }`}
      >
        Quality Score
        {sortColumn === "quality_score" ? (
          sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />
        ) : (
          <ArrowUp size={12} className="opacity-30" />
        )}
      </span>
    </th>    
 <th
      onClick={() => handleSort("execution_date")}
      className="px-4 pb-[6px] pt-[10px] text-[10px] text-left font-semibold w-[200px] cursor-pointer select-none"
    >
      <span
        className={`flex items-center gap-1 ${
          sortColumn === "execution_date" ? "text-[#0000A0]" : ""
        }`}
      >
        Execution Date
        {sortColumn === "execution_date" ? (
          sortOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />
        ) : (
          <ArrowUp size={12} className="opacity-30" />
        )}
      </span>
    </th>  </tr>

  {/* Input Row */}
  <tr>
    <th className="px-4 pt-0 pb-[10px]">
  <input
      value={columnSearch.data_product_name}
      onChange={(e) => onColumnSearchChange("data_product_name", e.target.value)}
      className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
      placeholder="Search "
    />    </th>
    <th className="px-4 pt-0 pb-[10px]">
 <input
      value={columnSearch.data_asset_name}
      onChange={(e) => onColumnSearchChange("data_asset_name", e.target.value)}
      className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
      placeholder="Search"
    />    </th>
    <th className="px-4 pt-0 pb-[10px]">
 <input
      value={columnSearch.rule_name}
      onChange={(e) => onColumnSearchChange("rule_name", e.target.value)}
      className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
      placeholder="Search "
    />    </th>
    <th className="px-4 pt-0 pb-[10px]">
 <input
      value={columnSearch.rule_description}
      onChange={(e) => onColumnSearchChange("rule_description", e.target.value)}
      className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
      placeholder="Search "
    />    </th>
    <th className="px-4 pt-0 pb-[10px]">
 <input
      value={columnSearch.check_name}
      onChange={(e) => onColumnSearchChange("check_name", e.target.value)}
      className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
      placeholder="Search "
    />    </th>
    <th className="px-4 pt-0 pb-[10px]">
<input
      value={columnSearch.dimension_name}
      onChange={(e) => onColumnSearchChange("dimension_name", e.target.value)}
      className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
      placeholder="Search"
    />    </th>
    <th className="px-4 pt-0 pb-[10px]">
 <input
      value={columnSearch.total_row_count}
      onChange={(e) => onColumnSearchChange("total_row_count", e.target.value)}
      className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
      placeholder="Search "
    />    </th>
    <th className="px-4 pt-0 pb-[10px]">
      <input className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none " placeholder="Search Error Rows" />
    </th>
    <th className="px-4 pt-0 pb-[10px]">
 <input
      value={columnSearch.quality_score}
      onChange={(e) => onColumnSearchChange("quality_score", e.target.value)}
      className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
      placeholder="Search "
    />    </th>
    <th className="px-4 pt-0 pb-[10px]">
 <input
      value={columnSearch.execution_date}
      onChange={(e) => onColumnSearchChange("execution_date", e.target.value)}
      className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
      placeholder="Search "
    />    </th>
  </tr>
</thead>


          

          <tbody>
            {/* {tableData.length === 0 ? (
              <tr>
                <td colSpan={10} className="text-center py-4 text-gray-500">
                  No data available
                </td>
              </tr>
            ) : ( */}
                 {loading ? (
                [...Array(5)].map((_, i) => (
                 <tr key={i}>
  <td className="px-[25px] py-2">
    <Skeleton variant="text" width={130} height={20} /> {/* Data Product Name */}
  </td>
  <td className="px-[25px] py-2">
    <Skeleton variant="text" width={130} height={20} /> {/* Data Asset Name */}
  </td>
  <td className="px-[25px] py-2">
    <Skeleton variant="text" width={110} height={20} /> {/* Rule Name */}
  </td>
  <td className="px-[25px] py-2">
    <Skeleton variant="text" width={120} height={20} /> {/* Rule Description */}
  </td>
  <td className="px-[25px] py-2">
    <Skeleton variant="text" width={130} height={20} /> {/* Check Name */}
  </td>
  <td className="px-[25px] py-2">
    <Skeleton variant="text" width={130} height={20} /> {/* Dimension Name */}
  </td>
  <td className="px-[25px] py-2">
    <Skeleton variant="text" width={130} height={20} /> {/* Total Rows */}
  </td>
  <td className="px-[25px] py-2">
    <Skeleton variant="text" width={110} height={20} /> {/* Error Rows */}
  </td>
  <td className="px-[25px] py-2">
    <Skeleton variant="rectangular" width={140} height={20} /> {/* Quality Score */}
  </td>
  <td className="px-[25px] py-2">
    <Skeleton variant="rectangular" width={120} height={20} /> {/* Execution Date */}
  </td>
</tr>
                ))
              ) : tableData.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center py-10 text-gray-500">
                    No Data Available
                  </td>
                </tr>
              ) : (
              tableData.map((row, index) => (
                // <tr
                //   key={index}
                //   className="hover:bg-[#E4F8F1] transition"
                //      style={{ backgroundColor: index % 2 === 0 ? "white" : "#eee" }}
                // >
                   <tr key={index} className={`transition-colors cursor-pointer ${index % 2 === 0 ? "bg-white" : "#eee"} hover:!bg-[#E4F8F1]`}>

                <td className="px-4 py-2 truncate text-[10px]  text-[#404040]">
  <div className="w-[130px] text-[10px]  text-[#404040]">
    {row.data_product_name ? (
      renderHighlightedText(
        truncateText(row.data_product_name, 30), 
        columnSearch.data_product_name
      )
    ) : (
      "null"
    )}
  </div>
</td>
<td className="px-4 py-2">
  <Tooltip
    title={
      row.data_asset_name
        ? row.data_asset_name.includes("|")
          ? row.data_asset_name.split("|")[1]
          : row.data_asset_name
        : "-"
    }
    slotProps={{
      tooltip: {
        sx: {
          backgroundColor: "#ece5e5ff",
          color: "black",
          fontSize: "10px",
          fontFamily: "Poppins",
          padding: "8px 10px",
          borderRadius: "6px",
          maxWidth: "400px",
          whiteSpace: "pre-wrap",
        },
      },
    }}
  >
    <span className="block w-[130px] text-[10px]  text-[#404040] truncate">
      {row.data_asset_name ? (
        renderHighlightedText(
          truncateText(
            row.data_asset_name.includes("|")
              ? row.data_asset_name.split("|")[1]
              : row.data_asset_name,
            30
          ),
          columnSearch.data_asset_name
        )
      ) : (
        "null"
      )}
    </span>
  </Tooltip>
</td>
<td className="px-4 text-[10px]  text-[#404040] py-2">
  <Tooltip
    title={
      row.rule_name
        ? row.rule_name.includes("|")
          ? row.rule_name.split("|")[1]
          : row.rule_name
        : "-"
    }
    slotProps={{
      tooltip: {
        sx: {
          backgroundColor: "#ece5e5ff",
          color: "black",
          fontSize: "10px",
          fontFamily: "Poppins",
          padding: "8px 10px",
          borderRadius: "6px",
          maxWidth: "400px",
          whiteSpace: "pre-wrap",
        },
      },
    }}
  >
    <span className="block text-[10px]  text-[#404040]">
      {row.rule_name ? (
        renderHighlightedText(
          truncateText(
            row.rule_name.includes("|")
              ? row.rule_name.split("|")[1]
              : row.rule_name
          ),
          columnSearch.rule_name
        )
      ) : (
        "null"
      )}
    </span>
  </Tooltip>
</td>


                   <td className="px-4 text-[10px]  text-[#404040] py-2">
  <Tooltip title={row.rule_description || "-"}
   slotProps={{
    tooltip: {
      sx: {
          backgroundColor: "#ece5e5ff",
        color: "black",
        fontSize: "10px",
        fontFamily: "Poppins",
        padding: "8px 10px",
        borderRadius: "6px",
        maxWidth: "400px",
        whiteSpace: "pre-wrap",
      },
    },
  }}>
    <span className="block text-[10px]  text-[#404040] w-[120px]">
      {row.rule_description
        ? renderHighlightedText(truncateTexts(row.rule_description), columnSearch.rule_description)
        : "null"}
    </span>
  </Tooltip>
</td>

                 <td className="px-4  text-[10px]  text-[#404040] py-2">
  <div className="w-[130px]">
    {row.check_name
      ? renderHighlightedText(truncateText(row.check_name), columnSearch.check_name)
      : "null"}
  </div>
</td>

<td className="px-4 py-2 text-[10px]  text-[#404040] capitalize">
  <div className="w-[130px] text-[10px]  text-[#404040] truncate">
    {row.dimension_name
      ? renderHighlightedText(row.dimension_name, columnSearch.dimension_name)
      : "null"}
  </div>
</td>           
       <td className="px-4 text-[10px]  text-[#404040] py-2">
  <div className="w-[100px] text-[10px]  text-[#404040]">
    {row.total_row_count
      ? renderHighlightedText(row.total_row_count.toString(), columnSearch.total_row_count)
      : "NA"}
  </div>
</td>
                 <td className="px-4 text-[10px]  text-[#404040] py-2">
  <div className="w-[100px] text-[10px]  text-[#404040]">
    {row.error_record_count
      ? renderHighlightedText(row.error_record_count, columnSearch.error_record_count)
      : "NA"}
  </div>
</td>
<td className="px-4 py-2 text-[10px]  text-[#404040]">
  <div className="w-[130px] text-[10px]  text-[#404040] truncate flex flex-col">
    {/* Score text */}
   <span
  style={{
    color: "black",
  }}
>
  {row.quality_score
    ? renderHighlightedText(row.quality_score, columnSearch.quality_score)
    : "-"}
</span>


    {/* Progress bar */}
 <div className="w-full bg-gray-200  rounded-full h-[8px] mt-1 relative overflow-hidden">
  <div
    className="h-[8px] rounded-full transition-all duration-300 absolute top-0 left-0"
    style={{
      width: `${parseFloat(row.quality_score) || 0}%`,
      backgroundColor:
        row.quality_score >= 95
          ? "#009F52"  // Green
          : row.quality_score >= 90
          ? "#FFC100"  // Yellow
          : "#FB0301", // Red
    }}
  />
</div>

  </div>
</td>



<td className="px-4 py-2 text-[10px]  text-[#404040]">
  <div className="w-[120px] truncate text-[10px]  text-[#404040]">
    {row.execution_date ? (
      renderHighlightedText(
        new Date(row.execution_date).toLocaleDateString("en-US", {
          month: "short",  // Oct
          day: "numeric",  // 30
          year: "numeric", // 2025
        }),
        columnSearch.execution_date
      )
    ) : (
      "-"
    )}
  </div>
</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Tables;

// import React from "react";
// import heartLoading from "../../assests/heartLoading.gif";
// import { Tooltip } from "@mui/material";
// import { ChevronLeft, ChevronRight } from "@mui/icons-material";
// import { Search } from "lucide-react";



// const Tables = ({
//   tableData = [],
//   loading = false,
//   ruleCount = 0,
//   error = null,
//   pagination = { page: 1, pageSize: 10, totalPages: 0, totalCount: 0 },
//   onPageChange = () => {},
//     onColumnSearchChange = () => {},  
//       columnSearch = {},  

// }) => {
//   const items = [
//     { color: "#FB0301", label: "< 90%" },
//     { color: "#FFC100", label: "90% – 95%" },
//     { color: "#009F52", label: "≥ 95%" },
//   ];
//   const tableContainerRef = React.useRef(null);
  

//   const truncateText = (text, maxLength = 30) =>
//     text && text.length > maxLength ? `${text.slice(0, maxLength)}...` : text || "NA";
//   const truncateTexts = (text, maxLength = 15) =>
//     text && text.length > maxLength ? `${text.slice(0, maxLength)}...` : text || "NA";

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center w-full overflow-hidden mt-20">
//         <div className="text-center flex flex-col items-center justify-center space-y-4">
//           <img src={heartLoading} alt="Loading..." className="h-32 w-32" />
//           <div className="space-y-2">
//             <p className="text-gray-700 text-xl font-semibold">Applying filters...</p>
//             <p className="text-gray-500 text-base">Updating results based on your selection</p>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return <div className="p-4 text-red-600">Error: {error}</div>;
//   }

//   const totalRecords = pagination.totalCount || 0;
//   const pageSize = pagination.pageSize || 10;
//   const currentPage = pagination.page || 1;
//   const totalPages =
//     pagination.totalPages && pagination.totalPages > 0
//       ? pagination.totalPages
//       : Math.max(1, Math.ceil(totalRecords / pageSize));

//   const gotoPage = (p) => {
//     const target = Math.max(1, Math.min(totalPages, p));
//     if (target !== currentPage) onPageChange(target);
//   };

//   return (
//     <div className="poppins-regular">
//       {/* Rule Count */}
     

//       {/* Score Legend & Pagination (unchanged) */}
//       <div className="flex items-center justify-between w-full mb-4">
//         <div className="flex items-center space-x-8">
//           <div className="flex space-x-6">
//             {items.map((item, idx) => (
//               <div key={idx} className="flex items-center space-x-2">
//                 <div
//                   className="w-[14px] h-[50px] rounded-full"
//                   style={{ backgroundColor: item.color.trim() }}
//                 />
//                 <div className="flex flex-col text-sm text-gray-500">
//                   <span className="labeling-items" style={{ fontSize: "12px" }}>
//                     Quality Score
//                   </span>
//                   <span className="labeling-items" style={{ fontSize: "12px" }}>
//                     {item.label}
//                   </span>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Pagination */}
//         <div>
//           {totalRecords > 0 && (
//             <div className="pagination">
//               <div className="pagination-controls flex items-center gap-2">
//                 <button
//                   disabled={currentPage === 1}
//                   onClick={() => gotoPage(currentPage - 1)}
//                   className="px-3 py-1 border rounded disabled:opacity-50"
//                 >
//                   Previous
//                 </button>

//                 {(() => {
//                   const pageButtons = [];
//                   const totalToShow = 5;

//                   let start = Math.max(1, currentPage - Math.floor(totalToShow / 2));
//                   let end = start + totalToShow - 1;

//                   if (end > totalPages) {
//                     end = totalPages;
//                     start = Math.max(1, end - totalToShow + 1);
//                   }

//                   if (start > 1) pageButtons.push(1);
//                   if (start > 2) pageButtons.push("...");

//                   for (let i = start; i <= end; i++) {
//                     pageButtons.push(i);
//                   }

//                   if (end < totalPages - 1) pageButtons.push("...");
//                   if (end < totalPages) pageButtons.push(totalPages);

//                   return pageButtons.map((p, idx) =>
//                     p === "..." ? (
//                       <span key={idx} className="px-2">
//                         ...
//                       </span>
//                     ) : (
//                       <button
//                         key={idx}
//                         onClick={() => gotoPage(p)}
//                         className={`px-3 py-1 border rounded ${
//                           currentPage === p ? "bg-[#0000a0] text-white" : ""
//                         }`}
//                       >
//                         {p}
//                       </button>
//                     )
//                   );
//                 })()}

//                 <button
//                   disabled={currentPage === totalPages}
//                   onClick={() => gotoPage(currentPage + 1)}
//                   className="px-3 py-1 border rounded disabled:opacity-50"
//                 >
//                   Next
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
      
//       <div className="flex justify-between items-center">
//         {/* Left side items */}
//         <div className="flex items-center gap-3 mb-[10px]">
//           {/* Search Input */}
//           <div className="relative w-[200px] mt-[6px] flex-shrink-0">
//             <input
//               type="text"
//               className="text-[9px] placeholder-gray-400 py-2 pl-[10px] w-full outline-none border border-gray-500 rounded"
//               placeholder="Search..."
             
//             />
      
//             {/* Search Icon */}
//             <Search
//               size={14}
//               color="#9CA3AF"
//               className="absolute right-[8px] top-1/2 -translate-y-1/2 pointer-events-none"
//             />
//           </div>
      
//           {/* Reset button */}
//           <button className="px-3 mt-[4px] py-1 text-gray-700 bg-white border border-gray-300 rounded"
        
//         >
//             Reset
//           </button>
      
//           {/* Scroll section */}
//        <div className="flex items-center gap-1 mt-[2px]">
//        <ChevronLeft
//         title="Scroll Left"
//           className="cursor-pointer"
//           onClick={() => {
//             if (tableContainerRef.current) {
//               tableContainerRef.current.scrollBy({ left: -200, behavior: "smooth" });
//             }
//           }}
//         />
//         <p className="text-[12px]">Scroll</p>
//         <ChevronRight
//           className="cursor-pointer"
//           title="Scroll Right"
//           onClick={() => {
//             if (tableContainerRef.current) {
//               tableContainerRef.current.scrollBy({ left: 200, behavior: "smooth" });
//             }
//           }}
//         />
//       </div>
      
//         </div>
      
//         {/* Right side - Export */}
//         <div className="mb-[10px]">
//         <span className="bg-blue-100 text-blue-800 text-sm px-3 py-1 rounded-md shadow-sm">
//           THERE ARE {ruleCount} RULES FOUND
//         </span>
//       </div>
//       </div>
      

//       {/* Table */}
// <div
//   ref={tableContainerRef}
//   style={{ overflowX: "auto", scrollBehavior: "smooth" }}
// >          <table className="min-w-full border-collapse border border-gray-200 text-sm">
        
//      <thead className="bg-[#9897FF1A] text-[#404040]">
//   {/* Header Row */}
//   <tr>
//     <th className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[200px]">Data Product Name</th>
//     <th className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left font-semibold w-[200px]">Data Asset Name</th>
//     <th className="px-4 pb-[6px] pr-[2px] text-[10px]  pt-[10px] text-left font-semibold w-[200px]">Rule Name</th>
//     <th className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left font-semibold w-[200px]">Rule Description</th>
//     <th className="px-4 pb-[6px] pr-[2px]  text-[10px] pt-[10px] text-left whitespace-nowrap font-semibold w-[200px]">Check Name</th>
//     <th className="px-4 pb-[6px] pr-[2px] text-[10px]  pt-[10px] text-left font-semibold whitespace-nowrap w-[200px]">Dimension Name</th>
//     <th className="px-4 pb-[6px] pr-[2px] text-[10px]  pt-[10px] text-left font-semibold whitespace-nowrap w-[200px]">Total Rows</th>
//     <th className="px-4 pb-[6px] pr-[2px] text-[10px]  pt-[10px] text-left font-semibold whitespace-nowrap ">Error Rows</th>
//     <th className="px-4 pb-[6px] pr-[2px] text-[10px] pt-[10px] text-left font-semibold whitespace-nowrap w-[200px]">Quality Score</th>
//     <th className="px-4 pb-[6px] pr-[2px] text-[10px]  pt-[10px] text-left font-semibold whitespace-nowrap w-[200px]">Execution Date</th>
//   </tr>

//   {/* Input Row */}
//   <tr>
//     <th className="px-4 pt-0 pb-[10px]">
//   <input
//       value={columnSearch.data_product_name}
//       onChange={(e) => onColumnSearchChange("data_product_name", e.target.value)}
//       className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
//       placeholder="Search Data Product Name"
//     />    </th>
//     <th className="px-4 pt-0 pb-[10px]">
//  <input
//       value={columnSearch.data_asset_name}
//       onChange={(e) => onColumnSearchChange("data_asset_name", e.target.value)}
//       className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
//       placeholder="Search Data Asset Name"
//     />    </th>
//     <th className="px-4 pt-0 pb-[10px]">
//  <input
//       value={columnSearch.rule_name}
//       onChange={(e) => onColumnSearchChange("rule_name", e.target.value)}
//       className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
//       placeholder="Search Rule Name"
//     />    </th>
//     <th className="px-4 pt-0 pb-[10px]">
//  <input
//       value={columnSearch.rule_description}
//       onChange={(e) => onColumnSearchChange("rule_description", e.target.value)}
//       className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
//       placeholder="Search Rule Description"
//     />    </th>
//     <th className="px-4 pt-0 pb-[10px]">
//  <input
//       value={columnSearch.check_name}
//       onChange={(e) => onColumnSearchChange("check_name", e.target.value)}
//       className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
//       placeholder="Search Check Name"
//     />    </th>
//     <th className="px-4 pt-0 pb-[10px]">
// <input
//       value={columnSearch.dimension_name}
//       onChange={(e) => onColumnSearchChange("dimension_name", e.target.value)}
//       className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
//       placeholder="Search Dimension Name"
//     />    </th>
//     <th className="px-4 pt-0 pb-[10px]">
//  <input
//       value={columnSearch.total_row_count}
//       onChange={(e) => onColumnSearchChange("total_row_count", e.target.value)}
//       className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
//       placeholder="Search Total Rows"
//     />    </th>
//     <th className="px-4 pt-0 pb-[10px]">
//       <input className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none " placeholder="Search Error Rows" />
//     </th>
//     <th className="px-4 pt-0 pb-[10px]">
//  <input
//       value={columnSearch.quality_score}
//       onChange={(e) => onColumnSearchChange("quality_score", e.target.value)}
//       className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
//       placeholder="Search Quality Score"
//     />    </th>
//     <th className="px-4 pt-0 pb-[10px]">
//  <input
//       value={columnSearch.execution_date}
//       onChange={(e) => onColumnSearchChange("execution_date", e.target.value)}
//       className="w-full text-[9px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none"
//       placeholder="Search Execution Date"
//     />    </th>
//   </tr>
// </thead>


          

//           <tbody>
//             {tableData.length === 0 ? (
//               <tr>
//                 <td colSpan={10} className="text-center py-4 text-gray-500">
//                   No data available
//                 </td>
//               </tr>
//             ) : (
//               tableData.map((row, index) => (
//                 <tr
//                   key={index}
//                   className="hover:bg-[#E4F8F1] transition"
//                      style={{ backgroundColor: index % 2 === 0 ? "white" : "#eee" }}
//                 >
//                   <td className="px-4 py-2 truncate">
//                     <div className="w-[170px]">{truncateText(row.data_product_name)}
//                       </div>
//                     </td>

//                   <td className="px-4 py-2">
//                     <Tooltip title={row.data_asset_name || "-"}>
//                       <span className="block">{truncateText(row.data_asset_name)}</span>
//                     </Tooltip>
//                   </td>

//                   <td className="px-4 py-2">
//                     <Tooltip title={row.rule_name || "-"}>
//                       <span className="block">{truncateText(row.rule_name)}</span>
//                     </Tooltip>
//                   </td>

//                   <td className="px-4 py-2">
//                     <Tooltip title={row.rule_description || "-"}>
//                       <span className="block w-[150px]">{truncateTexts(row.rule_description)}</span>
//                     </Tooltip>
//                   </td>

//                   <td className="px-4 py-2">
//                     <div className="w-[160px]">
//                     {truncateText(row.check_name)}
//                     </div>
//                     </td>
// <td className="px-4 py-2 capitalize">
//   <div className="w-[200px] truncate">{row.dimension_name ?? "-"}</div>
// </td>                  <td className="px-4 py-2">
//                     <div className="w-[140px]">{row.total_row_count ?? "NA"}
//                       </div>
//                     </td>
//                   <td className="px-4 py-2"
//                   >
//                     <div className="w-[150px]">
//                     {row.error_record_count ?? "NA"}
//                     </div></td>
// <td className="px-4 py-2">
//   <div className="w-[160px] truncate flex flex-col">
//     {/* Score text */}
//     <span
//       style={{
//         color:
//           row.quality_score < 90
//             ? "#FB0301"
//             : row.quality_score <= 94
//             ? "#FFC100"
//             : "#009F52",
//       }}
//     >
//       {row.quality_score ?? "-"}
//     </span>

//     {/* Progress bar */}
//     <div className="w-full h-[4px] bg-gray-200 rounded mt-1 relative">
//       <div
//         className="h-[4px] rounded absolute top-0 left-0"
//         style={{
//           width: `${row.quality_score ?? 0}%`,
//           backgroundColor:
//             row.quality_score < 90
//               ? "#FB0301"
//               : row.quality_score <= 94
//               ? "#FFC100"
//               : "#009F52",
//         }}
//       />
//     </div>
//   </div>
// </td>




//                  <td className="px-4 py-2">
//   <div className="w-[200px] truncate">
//     {row.execution_date
//       ? new Date(row.execution_date).toLocaleDateString("en-US", {
//           weekday: "short",
//           month: "short",
//           day: "numeric",
//           year: "numeric",
//         })
//       : "-"}
//   </div>
// </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default Tables;

// import { useMemo ,useState,useEffect} from "react";
// // import {
// //   MaterialReactTable,
// //   useMaterialReactTable,
// // } from "material-react-table";
// import heartLoading from "../../assests/heartLoading.gif";
// import {
//   MaterialReactTable,
//   useMaterialReactTable,
//   MRT_GlobalFilterTextField,
//   MRT_ShowHideColumnsButton,
//   MRT_ToggleFiltersButton,
//   MRT_ToggleDensePaddingButton,
//    MRT_ToggleFullScreenButton
// } from "material-react-table";
// import { IconButton } from "@mui/material";
// import { ChevronLeft, ChevronRight } from "@mui/icons-material";
// import { Tooltip } from "@mui/material";




// const Tables = ({
//   tableData = [],
//   loading = false,
//   ruleCount=0,
//   error = null,
//   pagination = { page: 1, pageSize: 10, totalPages: 0, totalCount: 0 },
//   onPageChange = () => {},
//    onSortChange = () => {},
//   onPageSizeChange = () => {},
// }) => {
//   const columns = useMemo(() => {
//     const commonHeadCellProps = {
//       sx: {
//         whiteSpace: "normal",
//         wordBreak: "break-word",
//         backgroundColor: "#9897FF1A",
//         color: "#404040",
//         border: "none",
//  fontFamily: "Poppins",
//   fontWeight: "500",
//         fontSize:'12px',
//            paddingTop:'30px',
//         paddingBottom:'30px',
//         paddingLeft:'20px',
//       },
//     };

//     const commonBodyCellProps = {
//       sx: {
//         whiteSpace: "normal",
//         wordBreak: "break-word",
//          fontFamily: "Poppins",
//         color: "black",
//         fontSize:'12px',
//         paddingTop: "10px",
//         paddingBottom: "10px",
//         border: "none",
//                 fontWeight:'300',
//       },
//     };

//     const getColumn = (accessorKey, header, width) => ({
//       accessorKey,
//       header,
//       size: width,
//       muiTableHeadCellProps: {
//         ...commonHeadCellProps,
//         sx: {
//           ...commonHeadCellProps.sx,
//           width: `${width}px`,
//         },
//       },
//       muiTableBodyCellProps: {
//         ...commonBodyCellProps,
//         sx: {
//           ...commonBodyCellProps.sx,
//           width: `${width}px`,
//         },
//       },
//     });

//     return [
//       getColumn("data_product_name", "Data Product Name", 100),
// {
//   ...getColumn("data_asset_name", "Data Asset Name", 120),
//   Cell: ({ cell }) => {
//     const value = cell.getValue();
//     if (!value || typeof value !== "string") return <span>-</span>;

//     const display =
//       value.includes("|") && value.split("|")[1]?.trim()
//         ? value.split("|")[1].trim()
//         : value;

//     // Limit visible text to 10 words
//     const words = display.split(/\s+/);
//     const shortText =
//       words.length > 10 ? words.slice(0, 10).join(" ") + "..." : display;

//     return (
//       <Tooltip
//         title={display}
//         slotProps={{
//           tooltip: {
//             sx: {
//               backgroundColor: "#ece5e5ff", // same as your rule_name tooltip
//               color: "black", // same text color
//               fontSize: "12px",
//               fontFamily: "Poppins",
//               padding: "8px 10px",
//               borderRadius: "6px",
//             },
//           },
//         }}
//       >
//         <span
//           style={{
//             display: "-webkit-box",
//             WebkitLineClamp: 1,
//             WebkitBoxOrient: "vertical",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//             wordBreak: "break-word",
//             lineHeight: "1.5",
//             maxWidth: "200px",
//             fontFamily: "Poppins",
//             fontWeight: 300,
//             fontSize: "12px",
//             color: "black",
//           }}
//         >
//           {shortText}
//         </span>
//       </Tooltip>
//     );
//   },
//   muiTableBodyCellProps: {
//     sx: {
//       ...commonBodyCellProps.sx,
//       maxWidth: "200px",
//       px: 2,
//       py: 1.5,
//     },
//   },
// },


// // {
// //   ...getColumn("rule_name", "Rule Name", 200),
// //  Cell: ({ cell }) => {
// //   const value = cell.getValue();
// //   if (!value || typeof value !== "string") return <span>-</span>;

// //   const display =
// //     value.includes("|") && value.split("|")[1]?.trim()
// //       ? value.split("|")[1].trim()
// //       : value;

// //   return (
// //     <span className="break-words max-w-[200px] text-left align-middle">
// //       {display}
// //     </span>
// //   );
// // },
// // }, 


// {
//   ...getColumn("rule_name", "Rule Name", 200),
//   Cell: ({ cell }) => {
//     const value = cell.getValue();
//     if (!value || typeof value !== "string") return <span>-</span>;

//     const display =
//       value.includes("|") && value.split("|")[1]?.trim()
//         ? value.split("|")[1].trim()
//         : value;

//     // Limit visible text to 10 words
//     const words = display.split(/\s+/);
//     const shortText =
//       words.length > 10 ? words.slice(0, 10).join(" ") + "..." : display;

//     return (
//       <Tooltip title={display}
//             slotProps={{
//     tooltip: {
//       sx: {
//         backgroundColor: "#ece5e5ff",
//         color: "black",
//         fontSize: "12px",
//         fontFamily: "Poppins",
//         padding: "8px 10px",
//         borderRadius: "6px",
//       },
//     },
//   }}>
//         <span
//           style={{
//             display: "-webkit-box",
//             WebkitLineClamp: 1,          
//             WebkitBoxOrient: "vertical",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//             wordBreak: "break-word",
//             lineHeight: "1.5",           
//             maxWidth: "250px",
//             fontFamily: "Poppins",
//             fontWeight: 300,
//             fontSize: "12px",
//             color: "black",
//           }}
//         >
//           {shortText}
//         </span>
//       </Tooltip>
//     );
//   },
//   muiTableBodyCellProps: {
//     sx: {
//       ...commonBodyCellProps.sx,
//       maxWidth: "250px",
//       px: 2,
//       py: 1.5,
//     },
//   },
// },


// // getColumn("rule_description", "Rule Description", 120),
// {
//   ...getColumn("rule_description", "Rule Description", 120),
//   Cell: ({ cell }) => {
//     const value = cell.getValue();
//     if (!value || typeof value !== "string") return <span>-</span>;

//     // Limit to 25 words for display
//     const words = value.split(/\s+/);
//     const shortText =
//       words.length > 10 ? words.slice(0, 10).join(" ") + "..." : value;

//     return (
//       <Tooltip title={value}
//             slotProps={{
//     tooltip: {
//       sx: {
//         backgroundColor: "#ece5e5ff",
//         color: "black",
//         fontSize: "12px",
//         fontFamily: "Poppins",
//         padding: "8px 10px",
//         borderRadius: "6px",
//       },
//     },
//   }}>
//         <span
//           style={{
//             display: "-webkit-box",
//             WebkitLineClamp: 1, 
//             WebkitBoxOrient: "vertical",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//             wordBreak: "break-word",
//             lineHeight: "1.5",
//             maxWidth: "250px",
//             fontFamily: "Poppins",
//             fontWeight: 300,
//             fontSize: "12px",
//             color: "black",
//           }}
//         >
//           {shortText}
//         </span>
//       </Tooltip>
//     );
//   },
//   muiTableBodyCellProps: {
//     sx: {
//       ...commonBodyCellProps.sx,
//       maxWidth: "250px",
//       px: 2,
//       py: 1.5,
//     },
//   },
// },

//       getColumn("check_name", "Check Name", 100),
//         {
//   ...getColumn("dimension_name", "Dimension Name", 100),
//   Cell: ({ cell }) => {
//     const value = cell.getValue();
//     return value
//       ? value.charAt(0).toUpperCase() + value.slice(1)
//       : "";
//   },
// },

//       // getColumn("total_row_count", "Total Rows", 60),
//       {
//   ...getColumn("total_row_count", "Total Rows", 60),
//   Cell: ({ cell }) => {
//     const value = cell.getValue();
//     return value || value === 0 ? value : "NA";
//   },
// },

// {
//   ...getColumn("error_record_count", "Error Rows", 60),
//   Cell: ({ cell }) => {
//     const value = cell.getValue();
//     return value || value === 0 ? value : "NA";
//   },
// },      // getColumn("quality_score", "Quality Score", 100),
//       {
//   ...getColumn("quality_score", "Quality Score", 100),
//   Cell: ({ cell }) => {
//     const value = cell.getValue();

//     // parse number from value if it's a string with '%'
//     let numericValue = null;
//     if (typeof value === "string") {
//       numericValue = parseFloat(value.replace("%", "").trim());
//     } else if (typeof value === "number") {
//       numericValue = value;
//     }

//     let color = "black"; // default color

//     if (numericValue !== null && !isNaN(numericValue)) {
//       if (numericValue < 90) {
//         color = "#FB0301";  // greenish
//       } else if (numericValue >= 90 && numericValue <= 94) {
//         color = "#FFC100";  // purple
//       } else if (numericValue >= 95) {
//         color = "#009F52";  // blue
//       }
//     }

//     return <span style={{ color }}>{value ?? "-"}</span>;
//   },
//   muiTableBodyCellProps: {
//     sx: {
//       ...commonBodyCellProps.sx,
//       width: "100px",
//     },
//   },
// },

//             // getColumn("execution_date", "Execution Date", 100),
//             {
//   ...getColumn("execution_date", "Execution Date", 120),
//   Cell: ({ cell }) => {
//     const value = cell.getValue();
//     if (!value) return "-";

//     const date = new Date(value);
//     // Short date format: Fri, Oct 17, 2025
//     const shortDate = date.toLocaleDateString("en-US", {
//       weekday: "short",
//       month: "short",
//       day: "numeric",
//       year: "numeric",
//     });

//     return <span>{shortDate}</span>;
//   },
// },


//     ];
//   }, []);

//   const [sorting, setSorting] = useState([]);
//   const [globalFilter, setGlobalFilter] = useState('');
// //   const [canScrollLeft, setCanScrollLeft] = useState(false);
// // const [canScrollRight, setCanScrollRight] = useState(false);

// //  useEffect(() => {
// //   const container = document.querySelector(".MuiTableContainer-root");
// //   if (!container) return;

// //   const updateScrollButtons = () => {
// //     const { scrollLeft, scrollWidth, clientWidth } = container;
// //     setCanScrollLeft(scrollLeft > 0);
// //     setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1);
// //   };

// //   updateScrollButtons();

// //   container.addEventListener("scroll", updateScrollButtons);
// //   window.addEventListener("resize", updateScrollButtons);

// //   return () => {
// //     container.removeEventListener("scroll", updateScrollButtons);
// //     window.removeEventListener("resize", updateScrollButtons);
// //   };
// // }, []);
//    const items = [
//   { color: "#FB0301", label: "< 90%" },           
//   { color: "#FFC100", label: "90% – 95%" },       
//   { color: "#009F52", label: "≥ 95%" },          
// ];


//   const table = useMaterialReactTable({
//   columns,
//   data: tableData,
// state: {
//   isLoading: loading,
//   sorting, 
//   globalFilter,

// },  manualPagination: true,
//   rowCount: pagination.totalCount,
//   enablePagination: false,
//   enableRowHover: false, 
//   manualSorting: true,           
//   onSortingChange: setSorting,   
//    onGlobalFilterChange: setGlobalFilter, 

//  initialState: {
//     showColumnFilters: true,   // show per-column filter inputs by default
//     showGlobalFilter: true,    // show the global search/filter input by default
//   },
//   muiTableContainerProps: {
//   sx: {
//     // target ALL input boxes (column filters)
//     '& .MuiInputBase-input': {
//       fontSize: '11px !important',
//       fontFamily: 'Poppins, sans-serif !important',
//       fontWeight: '400 !important',
//       color: '#404040 !important',
//     },
//     '& .MuiInputBase-input::placeholder': {
//       fontSize: '11px !important',
//       fontFamily: 'Poppins, sans-serif !important',
//       color: '#8a8a8a !important',
//       opacity: '1 !important',
//     },
//     // optional: make Clear (X) button smaller
//     '& .MuiSvgIcon-root': {
//       fontSize: '11px !important',
//     },
//   },
// },



// renderTopToolbar: ({ table }) => (
//     <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px' }}>
//       {/* Left side: Global Filter Input */}
//       <div>
//         <MRT_GlobalFilterTextField table={table} />
//       </div>

//       {/* Right side: Default buttons */}
//       <div style={{ display: 'flex', gap: '10px' }}>
//         <IconButton
//         title="Scroll Left"
//         size="small"
//         onClick={() =>
//           document
//             .querySelector(".MuiTableContainer-root")
//             ?.scrollBy({ left: -300, behavior: "smooth" })
//         }
//       >
//         <ChevronLeft />
//       </IconButton>
//                     <p className="mt-[9px]">Scroll</p>


//       <IconButton
//         size="small"
//         title="Scroll Right"
//         onClick={() =>
//           document
//             .querySelector(".MuiTableContainer-root")
//             ?.scrollBy({ left: 300, behavior: "smooth" })
//         }
//       >
//         <ChevronRight />
//       </IconButton>
//       {/* <IconButton
//   title="Scroll Left"
//   size="small"
//   onClick={() =>
//     document
//       .querySelector(".MuiTableContainer-root")
//       ?.scrollBy({ left: -300, behavior: "smooth" })
//   }
//   sx={{
//     opacity: canScrollLeft ? 1 : 0.4,   // 👈 fades when cannot scroll
//     transition: 'opacity 0.3s ease',
//   }}
// >
//   <ChevronLeft />
// </IconButton> */}
// {/* 
// <IconButton
//   title="Scroll Right"
//   size="small"
//   onClick={() =>
//     document
//       .querySelector(".MuiTableContainer-root")
//       ?.scrollBy({ left: 300, behavior: "smooth" })
//   }
//   sx={{
//     opacity: canScrollRight ? 1 : 0.4,  // 👈 fades when cannot scroll
//     transition: 'opacity 0.3s ease',
//   }}
// >
//   <ChevronRight />
// </IconButton> */}

      
//         <MRT_ShowHideColumnsButton table={table} />
//         <MRT_ToggleFiltersButton table={table} />
//         {/* <MRT_ToggleDensePaddingButton table={table} /> */}
//         <MRT_ToggleFullScreenButton table={table} /> 
//       </div>
//     </div>
//   ),
//   muiTableBodyRowProps: {
//     sx: {
//       '&.MuiTableRow-root:hover': {
//         backgroundColor: '#E4F8F1 !important',
//       },
//       transition: 'background-color 0.1s ease-in',
//     },
//   },

//   // muiTableProps: {
//   //   sx: {
//   //     border: 'none',
//   //   },
//   // },
//   // muiTableContainerProps: {
//   //   sx: {
//   //     border: 'none',
//   //   },
//   // },
// });
// const FRONTEND_TO_BACKEND = {
//   data_product_name: "product_name",
//   data_asset_name: "data_asset_name",
//   rule_description: "rule_description",
//   check_name: "check_name",
//   dimension_name: "dimension_name",
//   total_row_count: "total_rows",
//   error_record_count: "error_rows",
//   quality_score: "quality_score",
//   execution_date: "execution_date",
//   rule_name: "rule_name",
// };
// useEffect(() => {
//   if (sorting.length > 0) {
//     const sort = sorting[0];                 
//     const frontendKey = sort.id;             
//     const order = sort.desc ? "desc" : "asc";
//     const backendKey = FRONTEND_TO_BACKEND[frontendKey] ?? frontendKey;
//     onSortChange(backendKey, order);         
//   }
// }, [sorting, onSortChange]);

//   if (loading) {
//   return (
//     <div
//       className="flex items-center justify-center w-full overflow-hidden"
//       style={{
//         minHeight: "100%",       // fills available space naturally
//         marginTop: "80px",       
//       }}
//     >
//       <div className="text-center flex flex-col items-center justify-center space-y-4">
//         <img src={heartLoading} alt="Loading..." className="h-32 w-32" />
//         <div className="space-y-2">
//           <p className="text-gray-700 text-xl font-semibold">
//             Applying filters...
//           </p>
//           <p className="text-gray-500 text-base">
//             Updating results based on your selection
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }


//   if (error) {
//     return <div className="p-4 text-red-600">Error: {error}</div>;
//   }

//   const totalRecords = pagination.totalCount || 0;
//   const pageSize = pagination.pageSize || 10;
//   const currentPage = pagination.page || 1;
//   const totalPages = pagination.totalPages && pagination.totalPages > 0
//     ? pagination.totalPages
//     : Math.max(1, Math.ceil(totalRecords / pageSize));

//   const indexOfFirstRow = totalRecords === 0 ? 0 : (currentPage - 1) * pageSize + 1;
//   const indexOfLastRow = totalRecords === 0 ? 0 : Math.min(currentPage * pageSize, totalRecords);

//   const gotoPage = (p) => {
//     const target = Math.max(1, Math.min(totalPages, p));
//     if (target !== currentPage) {
//       onPageChange(target);
//     }
//   };

//   return (
//     <div className="poppins-regular">
     
//  <div className="mb-[20px]">
//       <span className="bg-blue-100 text-blue-800 text-sm px-3 py-1 rounded-md shadow-sm">
//   THERE ARE {ruleCount} UNIQUE RULES FOUND
// </span>
// </div>
// <div className="flex items-center justify-between w-full mb-4">
//   <div className="flex items-center space-x-8">
//     <div className="flex space-x-6">
//       {items.map((item, idx) => (
//         <div key={idx} className="flex items-center space-x-2">
//           <div
//             className="w-[14px] h-[50px] rounded-full"
//             style={{ backgroundColor: item.color.trim() }}
//           />
//           <div className="flex flex-col text-sm text-gray-500">
//             <span className="labeling-items" style={{fontSize:'12px'}}> Quality Score</span>
//             <span className="labeling-items"style={{fontSize:'12px'}}>{item.label}</span>
//           </div>
//         </div>
//       ))}
//     </div>



//   </div>

//   <div>
//     {totalRecords > 0 && (
//         <div className="pagination ">
//           <div className="pagination-controls flex items-center gap-2">
//             <button
//               disabled={currentPage === 1}
//               onClick={() => gotoPage(currentPage - 1)}
//               className="px-3 py-1 border rounded disabled:opacity-50"
//             >
//               Previous
//             </button>

            
// {(() => {
//   const pageButtons = [];
//   const totalToShow = 5;

//   let start = Math.max(1, currentPage - Math.floor(totalToShow / 2));
//   let end = start + totalToShow - 1;

//   if (end > totalPages) {
//     end = totalPages;
//     start = Math.max(1, end - totalToShow + 1);
//   }

//   if (start > 1) pageButtons.push(1);
//   if (start > 2) pageButtons.push("...");

//   for (let i = start; i <= end; i++) {
//     pageButtons.push(i);
//   }

//   if (end < totalPages - 1) pageButtons.push("...");
//   if (end < totalPages) pageButtons.push(totalPages);

//   return pageButtons.map((p, idx) =>
//     p === "..." ? (
//       <span key={idx} className="px-2">...</span>
//     ) : (
//       <button
//         key={idx}
//         onClick={() => gotoPage(p)}
//         className={`px-3 py-1 border rounded ${
//           currentPage === p ? "bg-[#0000a0] text-white" : ""
//         }`}
//       >
//         {p}
//       </button>
//     )
//   );
// })()}
//             <button
//               disabled={currentPage === totalPages}
//               onClick={() => gotoPage(currentPage + 1)}
//               className="px-3 py-1 border rounded disabled:opacity-50"
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       )}
//   </div>
// </div>


//       <MaterialReactTable   table={table} />

//       {/* {totalRecords > 0 && (
//         <div className="pagination mt-4 flex items-center justify-between">
//           <span>
//             Showing {indexOfFirstRow} to {indexOfLastRow} of {totalRecords} entries
//           </span>

//           <div className="pagination-controls flex items-center gap-2">
//             <button
//               disabled={currentPage === 1}
//               onClick={() => gotoPage(currentPage - 1)}
//               className="px-3 py-1 border rounded disabled:opacity-50"
//             >
//               Previous
//             </button>

// {(() => {
//   const pageButtons = [];
//   const totalToShow = 5;

//   let start = Math.max(1, currentPage - Math.floor(totalToShow / 2));
//   let end = start + totalToShow - 1;

//   if (end > totalPages) {
//     end = totalPages;
//     start = Math.max(1, end - totalToShow + 1);
//   }

//   if (start > 1) pageButtons.push(1);
//   if (start > 2) pageButtons.push("...");

//   for (let i = start; i <= end; i++) {
//     pageButtons.push(i);
//   }

//   if (end < totalPages - 1) pageButtons.push("...");
//   if (end < totalPages) pageButtons.push(totalPages);

//   return pageButtons.map((p, idx) =>
//     p === "..." ? (
//       <span key={idx} className="px-2">...</span>
//     ) : (
//       <button
//         key={idx}
//         onClick={() => gotoPage(p)}
//         className={`px-3 py-1 border rounded ${
//           currentPage === p ? "bg-blue-500 text-white" : ""
//         }`}
//       >
//         {p}
//       </button>
//     )
//   );
// })()}


//             <button
//               disabled={currentPage === totalPages}
//               onClick={() => gotoPage(currentPage + 1)}
//               className="px-3 py-1 border rounded disabled:opacity-50"
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       )} */}
//     </div>
//   );
// };

// export default Tables;
